/*
 * Froala Plugins & Plugin Styles
 * https://www.froala.com/wysiwyg-editor/docs/plugins
 * NOTE: Only enable plugins and styles as needed.
 * Must match enabled options in /config/pluginsEnabled.js
 * Do not import CSS here (for reference only), instead enable in ./plugins.scss
 */


/**
 * Align
 * Adds the align option.
 */
import 'froala-editor/js/plugins/align.min';
// no css


/**
 * Char Counter
 * Limits the number of characters that can be inserted in the editor.
 */
import 'froala-editor/js/plugins/char_counter.min';
// 'froala-editor/css/plugins/char_counter.min.css';


/**
 * Code Beautifier
 * Beautifies the code inside the code view mode.
 */
// import 'froala-editor/js/plugins/code_beautifier.min';
// no css


/**
 * Code View
 * Enables code view for the editor content.
 */
// import 'froala-editor/js/plugins/code_view.min';
// 'froala-editor/css/plugins/code_view.min.css';


/**
 * Colors
 * Adds the possibility to change the background and text colors.
 */
// import 'froala-editor/js/plugins/colors.min';
// 'froala-editor/css/plugins/colors.min.css';


/**
 * Draggable
 * Adds to drag content. E.g.: images, videos.
 */
import 'froala-editor/js/plugins/draggable.min';
// 'froala-editor/css/plugins/draggable.min.css';


/**
 * Embedly
 * Embeds any content from the web in the editor
 */
// import 'froala-editor/js/third_party/embedly.min';
// 'froala-editor/css/third_party/embedly.min.css';


/**
 * Emoticons
 * Makes your users smile
 */
// import 'froala-editor/js/plugins/emoticons.min';
// 'froala-editor/css/plugins/emoticons.min.css';


/**
 * Entities
 * Converts characters to special HTML entities.
 */
import 'froala-editor/js/plugins/entities.min';
// no css


/**
 * File
 * Upload any kind of files and special links will be inserted in the editor to download them.
 */
// import 'froala-editor/js/plugins/file.min';
// 'froala-editor/css/plugins/file.min.css';


/**
 * Font Awesome
 * Insert Font Awesome icons in the editor text.
 */
// import 'froala-editor/js/third_party/font_awesome.min';
// no css


/**
 * Font Family
 * Allows users to select from different font types.
 */
// import 'froala-editor/js/plugins/font_family.min';
// no css


/**
 * Font Size
 * Allows users to change the font size with pixel precision.
 */
// import 'froala-editor/js/plugins/font_size.min';
// no css


/**
 * Fullscreen
 * Adds fullscreen option.
 */
// import 'froala-editor/js/plugins/fullscreen.min';
// 'froala-editor/css/plugins/fullscreen.min.css';


/**
 * Help
 * Displays the shortcuts inside the editor.
 */
// import 'froala-editor/js/plugins/help.min';
// 'froala-editor/css/plugins/help.min.css';


/**
 * Image
 * Enables advanced image editing.
 */
// import 'froala-editor/js/plugins/image.min';
// 'froala-editor/css/plugins/image.min.css';


/**
 * Image Manager
 * Browse through and delete images on your server.
 */
// import 'froala-editor/js/plugins/image_manager.min';
// 'froala-editor/css/plugins/image_manager.min.css';


/**
 * Image Tui (see TUI Image Editor)
 * Make photos beautiful in seconds with stunning filters, frames, stickers, touch-up tools and more.
 */
// import 'froala-editor/js/third_party/image_tui.min';
// 'froala-editor/css/third_party/image_tui.min.css';


/**
 * Inline Class
 * Define custom classes for selected text.
 */
// import 'froala-editor/js/plugins/inline_class.min';
// no css


/**
 * Inline Style
 * Define custom styles for selected text.
 * Not used for tables
 */
// import 'froala-editor/js/plugins/inline_style.min';
// no css


/**
 * Line Breaker
 * Helper to add new lines between elements such as tables.
 */
// import 'froala-editor/js/plugins/line_breaker.min';
// 'froala-editor/css/plugins/line_breaker.min.css';


/**
 * Line Height
 * Allows users to select the line height for the current selected paragraph.
 */
// import 'froala-editor/js/plugins/line_height.min';
// no css


/**
 * Link
 * Enables advanced link editing.
 */
// import 'froala-editor/js/plugins/link.min';
// no css


/**
 * Lists
 * Allows users to insert lists in the editor.
 */
import 'froala-editor/js/plugins/lists.min';
// no css


/**
 * Paragraph Format
 * Allows users to change the type of a paragraph.
 */
// import 'froala-editor/js/plugins/paragraph_format.min';
// no css


/**
 * Paragraph Style
 * Allows user to choose a style for a paragraph.
 */
// import 'froala-editor/js/plugins/paragraph_style.min';
// no css


/**
 * Print
 * Adds print option to the toolbar.
 */
// import 'froala-editor/js/plugins/print.min';
// no css


/**
 * Quick Insert
 * Helper to add images, tables and other stuff easier.
 */
// import 'froala-editor/js/plugins/quick_insert.min';
// 'froala-editor/css/plugins/quick_insert.min.css';


/**
 * Quote
 * Adds quote option.
 */
// import 'froala-editor/js/plugins/quote.min';
// no css


/**
 * Save
 * Enables AJAX saving of the content inside the editor.
 */
// import 'froala-editor/js/plugins/save.min';
// no css


/**
 * Special Characters
 * Adds the possibility to inserts special characters.
 */
import 'froala-editor/js/plugins/special_characters.min';
// 'froala-editor/css/plugins/special_characters.min.css';


/**
 * Spell Checker
 * Allows the user to see and correct misspellings while typing.
 */
import 'froala-editor/js/third_party/spell_checker.min';
// 'froala-editor/css/third_party/spell_checker.min.css';


/**
 * Table
 * Basic and advanced operations on cells, rows and columns.
 */
import 'froala-editor/js/plugins/table.min';
// 'froala-editor/css/plugins/table.min.css';


/**
 * Url
 * Convert text to URL as you type.
 */
// import 'froala-editor/js/plugins/url.min';
// no css


/**
 * Video
 * Easily insert videos by URL or by embedded code.
 */
// import 'froala-editor/js/plugins/video.min';
// 'froala-editor/css/plugins/video.min.css';


/**
 * Word Paste
 * Cleans the HTML pasted from Word.
 */
import 'froala-editor/js/plugins/word_paste.min';
// no css


const pluginsEnabled = [
  'align',
  'charCounter',
  // 'codeBeautifier',
  // 'codeView',
  // 'colors',
  'draggable',
  // 'embedly',
  // 'emoticons',
  // 'entities',
  // 'file',
  // 'fontAwesome',
  // 'fontFamily',
  // 'fontSize',
  // 'fullscreen',
  // 'image',
  // 'imageTUI',
  // 'imageManager',
  // 'inlineClass',
  // 'inlineStyle',
  // 'lineBreaker',
  // 'lineHeight',
  // 'link',
  'lists',
  // 'paragraphFormat',
  // 'paragraphStyle',
  // 'quickInsert',
  // 'quote',
  // 'save',
  'table',
  // 'url',
  // 'video',
  'wordPaste'
];


/**
 * Plugin Toolbar Buttons
 * https://www.froala.com/wysiwyg-editor/docs/options#toolbarButtons
 * Constant containing all available plugins for use in toolbarButtons.config.js
 */
const pluginButtons = {
  align: 'align', // requires align plugin;
  color: 'color', // requires colors plugin;
  embedly: 'embedly', // requires embedly plugin;
  emoticons: 'emoticons', // requires emoticons plugin;
  fontFamily: 'fontFamily', // requires fontFamily plugin;
  fontSize: 'fontSize', // requires fontSize plugin;
  formatOL: 'formatOL', // require lists plugin;
  formatUL: 'formatUL', // require lists plugin;
  fullscreen: 'fullscreen', // requires fullscreen plugin;
  getPDF: 'getPDF', // requires print plugin;
  html: 'html', // requires codeView plugin;
  inlineStyle: 'inlineStyle', // requires inlineStyle plugin;
  inlineClass: 'inlineClass', // requires inlineClass plugin;
  insertFile: 'insertFile', // requires file plugin;
  insertImage: 'insertImage', // requires image plugin;
  insertLink: 'insertLink', // requires link plugin;
  insertTable: 'insertTable', // requires table plugin;
  insertVideo: 'insertVideo', // requires video plugin;
  paragraphFormat: 'paragraphFormat', // requires paragraphFormat plugin;
  paragraphStyle: 'paragraphStyle', // requires paragraphStyle plugin;
  print: 'print', // requires print plugin;
  quote: 'quote', // requires quote plugin;
  specialCharacters: 'specialCharacters', // requires specialCharacters plugin;
};

export { pluginButtons, pluginsEnabled };
